<div class="d-flex flex-row gap-3 align-items-center justify-content-end p-2 bg--surface border-top">
    
    @if(footerToolbarService.saveButtonVisible()){
        <app-footer-toolbar-save-button/>
    }

</div>